// Pedido explícito de Sue 2026-09-27: la pestaña "Historia" y "Generar copia
// de historia clínica" (pdfCopiaHistoria.ts) deben mostrar/incluir SOLO los
// documentos que de verdad pasaron por el panel de firma (PanelFirmaImpresion.tsx),
// sin importar de qué familia/pestaña vengan (Questionnaire genérico, discretos,
// consentimientos, FEMO, recetas — todos crean el DocumentReference con las
// MISMAS tres extensiones al firmar, ver PanelFirmaImpresion.tsx/RecetaWizard.tsx).
// Un documento subido a mano (SubirDocumento.tsx) NO las tiene — no pasó por
// ninguna firma electrónica, así que no cuenta como "guardado y firmado".
import type { DocumentReference } from '@medplum/fhirtypes';

export const EXT_FIRMA_SIGNATURE_REF = 'http://logiacare.ec/fhir/extension/firma-signature-ref';
export const EXT_FIRMA_FIRMADO_EN = 'http://logiacare.ec/fhir/extension/firma-firmado-en';

export function esDocumentoFirmado(doc: DocumentReference): boolean {
  return doc.status === 'current' && (doc.extension?.some((e) => e.url === EXT_FIRMA_SIGNATURE_REF) ?? false);
}

/** `firma-firmado-en` es el instante real de la firma — más preciso que `DocumentReference.date` (que estos recursos no siempre traen). */
export function fechaFirmaDe(doc: DocumentReference): string | undefined {
  return doc.extension?.find((e) => e.url === EXT_FIRMA_FIRMADO_EN)?.valueDateTime ?? doc.date;
}

export function tituloDocumentoFirmado(doc: DocumentReference): string {
  return doc.type?.text ?? doc.content?.[0]?.attachment?.title ?? doc.category?.[0]?.text ?? 'Documento firmado';
}
